import { AudioPodClient } from '../client/AudioPodClient';
import { Job } from '../types';

export class KaraokeService {
  constructor(private client: AudioPodClient) {}

  async generateKaraoke(
    options: {
      audioFile?: File | Blob | string;
      youtubeUrl?: string;
      customLyrics?: string;
      videoStyle?: string;
      waitForCompletion?: boolean;
      timeout?: number;
    }
  ): Promise<any> {
    const {
      audioFile,
      youtubeUrl,
      customLyrics,
      videoStyle = 'modern',
      waitForCompletion = false,
      timeout = 1200000
    } = options;

    if (!audioFile && !youtubeUrl) {
      throw new Error('Either audioFile or youtubeUrl must be provided');
    }

    const formData: Record<string, any> = { video_style: videoStyle };
    if (youtubeUrl) formData.youtube_url = youtubeUrl;
    if (customLyrics) formData.custom_lyrics = customLyrics;

    let job: Job;
    if (audioFile) {
      let fileData: File | Blob;
      if (typeof audioFile === 'string') {
        const fs = await import('fs');
        const fileBuffer = fs.readFileSync(audioFile);
        fileData = new Blob([fileBuffer], { type: 'audio/*' });
      } else {
        fileData = audioFile;
      }
      job = await this.client.uploadFile<Job>('/karaoke/generate', fileData, formData);
    } else {
      job = await this.client.post<Job>('/karaoke/generate', formData);
    }

    if (waitForCompletion) {
      return this.client.waitForJobCompletion(job.id, timeout);
    }
    return { job };
  }
}
